import {storageService} from 'services/storage';
import {createProxy} from 'interactors/errorHandler';

interface Dependencies {
  service?: StorageService;
  wndw?: Window;
}

export function create({
  service = storageService,
  wndw = window,
}: Dependencies = {}): StorageService {
  const methods = ['getItem', 'setItem'];
  const handler = (): void => wndw.alert('Oops! Local storage is not available!');
  return createProxy({service, handler, methods});
}
